"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectItems = void 0;
const React = require("react");
const SelectItems = (props) => {
    return (React.createElement("ul", { className: 'c-custom-select__dropdown' }, props.options.map((option, index) => {
        return (React.createElement("li", { className: `c-custom-select__item ${props.selectedOption &&
                props.selectedOption.id === option.id
                ? 'is-active'
                : ''}`, key: `item-${index}`, id: option.id, onClick: () => {
                props.onClick && props.onClick(option);
            } }, option.value));
    })));
};
exports.SelectItems = SelectItems;
